import React from 'react'
import { cerealesColor } from '../../../../config/cereales'
import ToneladasACargar from './ToneladasACargar'
import { COLORES } from '../../../../config/colores'
import FechasCargaBuque from './FechasCargaBuque'

const ListadoBuquesCalendario = ({ buques, obtenerEstimacionSemanal }) => {
  if (buques.length === 0) {
    return (
      <div className='no-ships-day'>
        <p>No hay cargas de buque del cereal seleccionado programadas para este día</p>
      </div>
    )
  }

  return (
    <div className='ship-list'>
      <div className='ship-list-header'>
        <h4>
          {buques.length} carga{buques.length !== 1 ? 's' : ''} de buque programada{buques.length !== 1 ? 's' : ''}
        </h4>
      </div>

      <div className='ships-container'>
        {buques.map((buque) => (
          <div key={buque.id} className='ship-card'>
            <div className='ship-header'>
              <div className='ship-name-section'>
                <div className='ship-cereal-indicator' style={{ backgroundColor: cerealesColor[buque.claveCereal.trim()] }} />
                <span className='detail-label'>Cereal: <span className='detail-value'> {buque.cereal} </span> </span>
              </div>
              {buque.buque &&
                <span className='detail-label'>
                  Buque: <span className='detail-value'> {buque.buque}</span>
                </span>
              }
              <div style={{ fontWeight: 'bold', color: COLORES.grey.mediumDark, display: 'flex' }}>
                Total buque: {buque.totalAnunciado.toLocaleString()} tn.
                <FechasCargaBuque data={buque} actualizarEstimacion={obtenerEstimacionSemanal} />
              </div>
            </div>
            <div className='ship-detail' style={{ justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'flex-end' }}>
              <span className='detail-label'>Exportador: <span className='detail-value'> {buque.nombreExportador}</span></span>
              <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <span className='detail-label' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>A cargar:
                  <ToneladasACargar value={buque.toneladas} entry={buque} /> tn.
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ListadoBuquesCalendario
